import { Component } from '@angular/core';
import { BaseComponent } from '../shared/base-components/base.component';

@Component({
    selector: '[not-found]',
    templateUrl: './api-response-internal-server-error.html'
})

export class ApiResponseInternalServerErrorComponent extends BaseComponent {

    constructor(
    ) {
        super();

    }

    ngOnInit() {

    }
}
